export default __webpack_public_path__ + "static/media/melcor-developments-logo.3a6f7586.png";